goog.provide('el8.appchart.medsHx.main');

goog.require('el8.model.identify');
goog.require('el8.service.urls');
goog.require('el8.template.render.medsHx');
goog.require('el8.uiwidget.DrawerDialog');
goog.require('el8.uiwidget.nonAlarmingAlert');
goog.require('el8.appchart.actions.dcMedOrder');
goog.require('el8.appchart.actions.medOrder');
goog.require('el8.appchart.actions.medOrderThread');
goog.require('el8.uiwidget.NewActionsMenu');

goog.require('el8.ptdata.medOrderThreads');
goog.require('el8.ptdata.rxHistoryDownloadSummaries');
goog.require('el8.appchart.medsHx.reconciler');
goog.require('el8.appchart.medsHx.renderer');
goog.require('el8.appchart.medsHx.detailsDrawer');
goog.require('el8.appchart.medsHx.util');
goog.require('el8.app.pageLayout');
goog.require('el8.appchart.permissions');
goog.require('el8.util.amplitude.patientChartHelpers');


el8.appchart.medsHx.main = (function() {

    var _currThread = null;
    var _currThreadIds = [];

    var that = new el8.uiwidget.DrawerDialog({
        title: 'Medication History',
        modal: false,
        height: function() {
            return el8.app.pageLayout.getChartInnerHeight();
        },
        width: 570,
        showXButton: true,
        contentFn: el8.template.render.medsHx.content,
        drawerConstructor: el8.appchart.medsHx.detailsDrawer,
        drawerOpts: {
            width: 500,
            height: function() { return el8.app.pageLayout.getAppHeight() - 130; },
            contentFn: el8.template.render.medsHx.drawerContent,
            mergeButtonSetFn: function(var_args) {
                return that._reconciler.getMergeButtonSet.apply(
                    that._reconciler, arguments);
            },
            moveFillButtonSetFn: function(var_args) {
                return that._reconciler.getMoveFillButtonSet.apply(
                    that._reconciler, arguments);
            }
        }
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that._initSearchField();
        that._renderer = new el8.appchart.medsHx.renderer({
            drawerContainer: that.getDrawerContainer(),
            container: that.getContentElt()
        });
        that._reconciler = new el8.appchart.medsHx.reconciler({
            renderer: that._renderer,
            container: that.getContentElt(),
            drawerContainer: that.getDrawerContainer(),
            openReconcileDrawerFn: function(var_args) {
                that.openDrawer.apply(that, arguments);
            },
            closeReconcileDrawerFn: function(var_args) {
                that.closeDrawer.apply(that, arguments);
            }
        });
        that._actionsMenu = new el8.uiwidget.NewActionsMenu({
            container: that.getContentElt(),
            anchorTop: $('.meds-hx-content', that.getContentElt()),
            menuId: 'meds-history-actions-menu',
            width: 155,
            highlightClassList: ['el8FeedItemSelected', 'el8ItemSelected']
        });
        that._bindTriggers();
    };

    that.triggerCheckPmp = function(triggerLocation) {
        el8.util.amplitude.logStartCheckPMPRequest(triggerLocation)
        return $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('checkPMP'),
                success: function(data) {
                    if (data.redirect_link) {  // Success == redirect_link
                        window.open(data.redirect_link);
                        el8.util.amplitude.logCheckPMPResponseReceived("");
                        el8.appchart.mainFeeds.chart.update();
                    } else if (data.message && data.login_link) {
                        el8.uiwidget.confirm(
                          data.message,
                          function () { window.open(data.login_link); },
                          null,
                          {
                            msgTemplateFn: function() { return data.message; },
                            prefHeight: 270,
                            yesBtnText: "Continue to PMP Login",
                            noBtnText: "Cancel",
                            title: "Must log into PMP manually",
                          }
                        );
                        el8.util.amplitude.logCheckPMPResponseReceived(data.message);
                    } else if (data.message) {  // If no link, show the message passed back
                        el8.uiwidget.nonAlarmingAlert(data.message);
                        el8.util.amplitude.logCheckPMPResponseReceived(data.message);
                    } else {  // Unexpected that there's no link or message
                        var msg = "Unexpected response from backend";
                        el8.uiwidget.alert(msg);
                        el8.util.amplitude.logCheckPMPResponseReceived(msg);
                    }
                },
                error: function() {
                    var msg = "Error communicating with backend"
                    el8.uiwidget.alert(msg);
                    el8.util.amplitude.logCheckPMPResponseReceived(msg);
                }
         });
    };

    that._bindTriggers = function() {
        that._renderer.enableTriggers();
        that.getContentElt().on('click', '.print-meds-hx-trigger',  function(e) {
            window.open(el8.service.urls.get('printCompMedsHistory'));
        });
        that.getContentElt().on('click', '.check-pmp-trigger',  function(e) {
            e.preventDefault();
            that.triggerCheckPmp($(e.target).attr('data-amplitude-source'));
            return false;
        });
        that.getContentElt().on('click', '.bulk-refill-trigger',  function(e) {
            var threads = el8.ptdata.medOrderThreads.getSortedPermRx(true)
            .concat(el8.ptdata.medOrderThreads.getSortedPermOtc(true));

            el8.appchart.mgr.orderForm.bulkRefillMedOrders(
              threads.map(function(thread) {
                return thread.getLatestOrder();
              })
            )
        });
        that.getContentElt().on('click', '.meds-hx-all-view-trigger',  function(e) {
            that.clearContents();
            return false;
        });
        that.getContentElt().on('click', '.select-thread-trigger',  function(e) {
            var threadId = $(this).attr('data-id')*1;
            that.renderThread(threadId);
            return false;
        });
        that.getContentElt().on('click', '.details-trigger',  function(e) {
            if (!that._renderer.isTriggersActive()) { return; }
            var orderId = $(this).attr('data-id')*1;
            that._showRxDetail(orderId);
            return false;
        });
        that.getContentElt().on('click', '.fill-title, .fill-detail-status',  function(event) {
            if (!that._renderer.isTriggersActive()) { return; }
            var $elt = $(this).closest('.fill-content');
            var $detail = $('.fill-detail', $elt);
            var $summary = $('.fill-summary', $elt);
            if ($detail.is(':hidden')) {
                // Do expand!
                $detail.show();
                $summary.hide();
            } else {
                // Do collapse!
                $detail.hide();
                $summary.show();
            }
            return false;
        });
        that.getContentElt().on('click', '.acknowledge-trigger',  function(event) {
            var $target = $(this);
            if (!$target.prop('disabled')) {
                $target.prop('disabled', true);
                var itemId = el8.util.feed.fromFeedItemId($target.attr('_fid'))['id'];
                el8.appchart.medsMgr.acknowledgeRxDownloadThread(itemId, function() {
                    $target.prop('disabled', false);
                });
            }
            return false;
        });
        that.getContentElt().on('click', '.thread-actions-trigger',  function(event) {
            var itemId = el8.util.feed.fromFeedItemId($(this).attr('_fid'))['id'];
            var item = el8.ptdata.medOrderThreads.getById(itemId*1);
            that._actionsMenu.display(
                $(this), item,
                {top: 20, left: 20},
                el8.appchart.actions.medOrderThread({item: item, isMedsHistory: true, amplitudeSource: $('#meds-hx-all-view').text() ? 'meds hx main' : 'meds hx detail thread'}),
                null,
                'el8FeedItemSelected'
            );
            return false;
        });
        that.getContentElt().on('click', '.actions-trigger',  function(event) {
            if (!that._renderer.isTriggersActive()) { return; }
            var $elt = $(this);
            var itemId = $elt.attr('data-id')*1;
            var type = $(this).attr('data-type');
            if (type === 'fill') {

                var fill = el8.ptdata.medOrderFills.getById(itemId);
                var isRxDownload = fill.isRxDownload();
                var summary = el8.ptdata.rxHistoryDownloadSummaries
                    .getSummaryByFillId(fill.getId());

                var menu = [];
                if (!fill.isRxDownload()) {
                    menu.push({
                        actionText: 'Move',
                        actionFn: function() {
                            that._reconciler.beginFillMove(itemId);
                        }
                    });
                }
                menu.push({
                    actionText: 'Remove',
                    actionFn: function() {
                        el8.ptdata.medOrderFills.deleteItem(itemId, false, {
                            successCb: function() {
                                that._renderer.removeFillById(itemId);
                                if (summary) {
                                    summary.removeFillId(itemId);
                                    if (isRxDownload) {
                                        el8.appchart.mainFeeds.reqAct.refreshItem(summary);
                                    } else {
                                        el8.appchart.mainFeeds.chart.refreshItem(summary);
                                    }
                                    el8.appchart.refpanel.meds.renderRxDownload();
                                }
                            }
                        });
                    }
                });
                that._actionsMenu.display(
                    $(this),
                    null,
                    {top: 18, left: 5},
                    menu,
                    null,
                    'el8ItemSelected'
                );
                return false;
            } else if (type === 'order') {
                var item = null, menu = null;
                if (el8.model.idToModelClass(itemId*1) === 'MedOrder') {
                    item = el8.ptdata.medOrders.getById(itemId*1);
                    menu = el8.appchart.actions.medOrder({item: item, isMedsHistory: true, amplitudeSource: 'meds hx detail script'});

                } else if (el8.model.idToModelClass(itemId*1) === 'DiscontinueMedOrder') {
                    item = el8.ptdata.dcMedOrders.getById(itemId*1);
                    menu = el8.appchart.actions.dcMedOrder({item: item, isMedsHistory: true});
                }
                that._actionsMenu.display(
                    $(this), item, {top: 17, left: 5}, menu, null, 'el8ItemSelected');
            }
            return false;
        });
        el8.ptdata.medOrderFills.bind(EVENTS.MOVED, function(arg, arg2, arg3) {
            // if arg2 and arg3 are present, then
            //  - arg is fillId
            //  - arg2 is sourceOrderId
            //  - arg3 is destinationOrderId
            // else, arg is threadId to refresh
            if (arg2 && arg3) {
                that._renderer.refreshMedOrder(el8.ptdata.medOrders.getById(arg2));
                that._renderer.refreshMedOrder(el8.ptdata.medOrders.getById(arg3));
            } else {
                // arg is threadId
                if (that._isThreadDisplayed(arg)) {
                    that.renderThread(arg);
                }
            }
        });
        el8.ptdata.medOrders.bind('all', function(eventName, arg) {
            if (arg.isSignedOff() && (eventName === EVENTS.UPDATED ||
                    eventName === EVENTS.DELETED)) {
                if ((arg instanceof el8_Entity) &&
                        that._isThreadDisplayed(arg.getThreadId())) {
                    that._refreshThreadById(arg.getThreadId());
                    if (that._isOrderDetailsDisplayed(arg.getId())) {
                        if (eventName === EVENTS.UPDATED) {
                            that._refreshRxDetail();
                        } else if (eventName === EVENTS.DELETED) {
                            that._hideRxDetail();
                        }
                    }
                }
            }
        });
        el8.ptdata.dcMedOrders.bind('all', function(eventName, arg) {
            if (eventName === EVENTS.UPDATED ||
                    eventName === EVENTS.DELETED) {
                if ((arg instanceof el8_Entity) &&
                        that._isThreadDisplayed(arg.getThreadId())) {
                    that._refreshThreadById(arg.getThreadId());
                }
            }
        });
        el8.ptdata.medOrderThreads.bind('all', function(eventName, arg, arg2, arg3, arg4) {
            if (eventName === EVENTS.UPDATED) {
                // arg is the new thread; arg2 may be an rx download thread this thread replaced
                if (arg instanceof el8_Entity) {
                    if ( that._isThreadDisplayedMain(arg.getId()) ||
                            (arg2 instanceof el8_Entity && that._isThreadDisplayedMain(arg2.getId())) ) {
                        // if arg2 is currently displayed, we still want to render arg,
                        // because arg (the real thread) has replaced arg2 (the virtual thread)
                        that._refreshThreadById(arg.getId());
                    } else if ( that._isThreadDisplayedRelated(arg.getId()) ||
                            (arg2 instanceof el8_Entity && that._isThreadDisplayedRelated(arg2.getId())) ) {
                        that._refreshRelatedThreads();
                    } else {
                        that.clearContents();
                    }
                }
            } else if (eventName === EVENTS.DELETED) {
                if ((arg instanceof el8_Entity) && that._isThreadDisplayed(arg.getId())) {
                    if (!arg2 || (arg2['medsHxUpdate'] !== false)) {
                        if (_currThread && (_currThread.getId() === arg.getId())) {
                            that.clearContents();
                        } else {
                            that._removeThreadById(arg.getId());
                        }
                    }
                } else {
                    that._removeThreadById(arg.getId());
                }
            } else if (eventName === EVENTS.MERGED) {
                var isAnyThreadDisplayed = function(list) {
                    for (var i=0; i<list.length; i++) {
                        if (that._isThreadDisplayed(list[i])) { return true; }
                    }
                    return false;
                };
                if (that._isThreadDisplayed(arg) || isAnyThreadDisplayed(arg2)) {
                    // arg is primary_thread_id
                    // arg2 is destination_thread_ids
                    // arg3 is moved_order_ids
                    // arg4 is new_latest_order_id
                    that.renderMergedThread(arg, arg3, arg4);
                }
            }
        });
    };

    var super_show = that.show;
    that.show = function(spec) {

        super_show.call(that);
        // If no args passed in, then show "all" view
        if (!spec) {
            that.clearContents();
            return;
        }

        // Else, show specific thread view
        spec = spec || {};
        var threadId = spec.threadId || null;

        var order = null;
        if (spec.medOrderId) {
            order = el8.ptdata.medOrders.getById(spec.medOrderId);
            threadId = order.getThreadId();
        } else if (spec.dcMedOrderId) {
            order = el8.ptdata.dcMedOrders.getById(spec.dcMedOrderId);
            threadId = order.getThreadId();
        }

        if (threadId) {
            that.renderThread(
              threadId,
              order ? order.getId() : null,
              spec.doMoveMerge,
              function() {
                // Init surescripts explanation tooltip
                el8.service.tooltip.create({
                  anchor: $('.explain-surescripts-trigger', that.getContentElt()),
                  text: 'The pharmacy has permanently accepted the order.'
                });
              }
            );
        }
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        that.reset();
    };

    var super_openDrawer = that.openDrawer;
    that.openDrawer = function(spec) {
        super_openDrawer.call(that, spec);
        // Init surescripts explanation tooltip
        el8.service.tooltip.create({
          anchor: $('.explain-surescripts-trigger', that.getDrawerContainer()),
          text: 'The pharmacy has permanently accepted the order.'
        });
    };

    var super_closeDrawer = that.closeDrawer;
    that.closeDrawer = function() {
        super_closeDrawer.call(that);
        that._renderer.removeAllHighlight();

        // Destroy surescripts explanation tooltip
        el8.service.tooltip.destroy($('.explain-surescripts-trigger', that.getDrawerContainer()));
    };

    that.reset = function() {
        that._reconciler.reset();
        that._searchMindreader.hide();
        that.closeDrawer();
        that._actionsMenu.hide();

        // Destroy surescripts explanation tooltip
        el8.service.tooltip.destroy($('.explain-surescripts-trigger', that.getContentElt()));
    };

    // Returns whether this dialog is open; if threadId is provided
    // it check whether specifically that thread is open in the detail view
    that.isShowing = function(threadId) {
        var dialogIsOpen = that.isOpen();
        if (!threadId) {
            return dialogIsOpen;
        }
        return dialogIsOpen && that._isThreadDisplayed(threadId);
    };

    /**
     * Methods to retrieve or affect dialog state, regardless of view
     */
    that._isThreadDisplayedMain = function(id) {
        return _currThread && (_currThread.getId() === id);
    };
    that._isThreadDisplayedRelated = function(id) {
        for (var i=0; i<_currThreadIds.length; i++) {
            if (_currThreadIds[i] === id) { return true; }
        }
        return false;
    };
    that._isThreadDisplayed = function(id) {
        return that._isThreadDisplayedMain(id) || that._isThreadDisplayedRelated(id);
    };
    that._isOrderDetailsDisplayed = function(orderId) {
        var drawer = that.getDrawer();
        return drawer && drawer._currOrder ? (drawer._currOrder.getId() === orderId) : false;
    };
    that._removeThreadById = function(threadId) {
        that._renderer.removeThreadById(threadId);
    };
    that._refreshThreadById = function(threadId) {
        var thread = el8.ptdata.medOrderThreads.getById(threadId);
        if (thread) {
            _currThread = thread;
            that._renderer.refreshThread(_currThread);
            if (_currThread && (_currThread.getId() === threadId)) {
                $('.meds-hx-item-title', that.getContentElt())
                    .text(that._renderer.getThreadTitle(_currThread));
            }
        } else {
            that.clearContents();
        }
    };
    that._refreshRelatedThreads = function() {
        if (!_currThreadIds || !_currThreadIds.length) { return; }
        var threads = _currThreadIds.map(function(id) {
            return el8.ptdata.medOrderThreads.getById(id);
        });
        that._drawRelatedThreads(threads);
    };

    /**
     * ALL THREADS VIEW
     */
    that.clearContents = function(successCb) {
        if (that._isInit) {
            that.reset();
            that._removeRelatedSection();
            $('.meds-hx-item', that.getContentElt()).empty();
            $('.meds-hx-item-title', that.getContentElt()).empty();

            _currThread = null;
            _currThreadIds = [];

            that._showAllThreadsView(successCb);
        }
    };
    that._hideAllThreadsView = function() {
        $('#meds-hx-all-view', that.getContentElt()).empty();
        $('.meds-hx-all-view-trigger', that.getContentElt()).show();
    };
    that.isBulkRefillEnabled = function() {
        if (!el8Globals['FEATURES']['ERx']) {
            return false;
        }
        return el8.appchart.permissions.allow('prescribeMeds');
    };

    that.isCurrentUserPhysician = function() {
        return (el8Globals.USER_STAFF_TYPE === 'Physician');
    };

    that._showAllThreadsView = function(successCb) {
        $('.meds-hx-all-view-trigger', that.getContentElt()).hide();
        $('#meds-hx-all-view', that.getContentElt()).empty().addClass('dataLoading');
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('medsSummarySearch'),
            success: function(data) {
                var buttons = [
                    {name: 'Actions', htmlClass: 'thread-actions-trigger', hasDropdown: true}
                ];
                $('#meds-hx-all-view', that.getContentElt()).html(
                    el8.template.render.medsHx.allThreadsView({
                        permRx: data['results']['perm_rx'],
                        permOtc: data['results']['perm_otc'],
                        temp: data['results']['temporary'],
                        dc: data['results']['discontinued'],
                        canceled: data['results']['canceled'],
                        hasActions: true,
                        bulkRefillEnabled: that.isBulkRefillEnabled(),
                        currentUserIsPhysician: that.isCurrentUserPhysician(),
                        buttons: buttons
                    })
                ).removeClass('dataLoading');
                var disabledPMP = $('.check-pmp-tooltip'); // Don't apply tooltip if no button
                if (disabledPMP.length !== 0) {
                    el8.service.tooltip.create({
                      anchor: disabledPMP,
                      text: 'PMP only available to providers.'
                    });
                }
                that.renderAllThreadsRxDownload();
                if (successCb) { successCb(); }
            }
        });
    };
    that.renderAllThreadsRxDownload = function() {
        var toHighlight = el8.ptdata.rxHistoryDownloadSummaries.getAllUnsignedMeds();
        var threadsToHighlight = toHighlight['threadIds'];
        var $container = $('#meds-hx-all-view', that.getContentElt());
        for (var i=0; i<threadsToHighlight.length; i++) {
            $('.thread-item[data-id="'+threadsToHighlight[i]+'"]', $container)
                .addClass(el8.appchart.medsHx.util.HIGHLIGHT_CLASS);
        }
    };

    /**
     * SINGLE THREAD VIEW -- Helper methods
     */
    that.renderThread = function(threadId, orderId, doMoveMerge, callbackFn) {

        /** Render a thread and its related threads **/
        that._hideAllThreadsView();
        that._actionsMenu.hide();

        /**
         * If thread is being displayed already and we want to do a move/merge,
         * just open up the drawer
         */
        if (that._isThreadDisplayed(threadId) && doMoveMerge) {
            if (orderId) {
                that._doDisplayOrder(orderId, doMoveMerge);
            } else {
                that._reconciler.beginThreadMerge(threadId);
            }
        /**
         * Otherwise, go and fetch thread and render it
         */
        } else {
            $('.meds-hx-item', that.getContentElt()).empty().addClass('dataLoading');
            that._removeRelatedSection();
            that._fetchThread(threadId, function(data) {
                _currThread = el8.ptdata.medOrderThreads.create(data, true);
                _currThreadIds = data['related_thread_ids'];
                that._doRenderThread(orderId, doMoveMerge);
                if (callbackFn) { callbackFn(); }
            });
        }
    };
    that._doRenderThread = function(orderId, doMoveMerge) {
        that._searchField.getInputField().blur();
        that._drawMainThread();
        if (_currThreadIds.length) {
            that._displayRelatedSection();
        }
        if (!orderId) {
            that.closeDrawer();
            if (doMoveMerge) {
                that._reconciler.beginThreadMerge(_currThread.getId());
            }
        } else {
            that._doDisplayOrder(orderId, doMoveMerge);
        }
    };
    that._doDisplayOrder = function(orderId, doMoveMerge) {
        var order = el8.ptdata.fetch({
            id: orderId,
            model_class: el8.model.idToModelClass(orderId)
        });
        if (doMoveMerge) {
            that._reconciler.beginOrderMove(orderId);
        } else {
            if (order.is('MedOrder') &&
                    !order.isDocumentMed() && !order.isRxDownload()) {
                that._showRxDetail(orderId);
            }
        }
    };
    that._fetchThread = function(arg, successCb) {
        var url, data;
        if (arg instanceof Array) {
            url = el8.service.urls.get('fetchMultipleThreadDetail');
            data = {id: arg};
        } else {
            url = el8.service.urls.get('fetchThreadDetail', [arg]); // arg is threadId
            data = null;
        }
        $.el8_ajax({
            type: 'GET',
            url: url,
            data: data,
            success: function(data) {
                if (successCb) { successCb(data); }
            }
        });
    };
    that._drawMainThread = function() {
        $('.meds-hx-item', that.getContentElt()).removeClass('dataLoading')
            .html(that._renderer.getThreadContent(_currThread));
        $('.meds-hx-item-title', that.getContentElt())
            .text(that._renderer.getThreadTitle(_currThread));
    };
    that.renderMergedThread = function(threadId, movedOrderIds, newLatestOrderId) {
        that.renderThread(threadId, null, false, function() {
            if (movedOrderIds) {
                that._renderer.highlight(movedOrderIds); }
            // If thread has a new latest order, then highlight thread title
            if (newLatestOrderId) { that._renderer.highlight(threadId, true); }
        });
    };
    that.highlight = function(list) {
        that._renderer.highlight.call(that._renderer, list);
    };

    /**
     * Initializing the autocomplete
     */
    that._initSearchField = function() {
        var $input = $(':input[name="searchMeds"]', that.getContentElt());
        that._searchField = el8.service.infoField.addInfoField({
            field: $input,
            maxLength: 200,
            rows: 1,
            noGrow: true,
            infoText: 'Search for meds pt is or has ever been on...'
        });
        that._searchMindreader = new el8.uiwidget.LegacyMindreader({
            url: el8.service.urls.get('medsSummarySearch'),
            limit: 500,
            containerWidth: 520,
            entryHeight: 25,
            showNoMatches: true,
            minQueryLength: 0,
            formatResult: function(item) {
                return el8.template.render.medsHx.mindreaderResult(item);
            },
            formatSelected: function(item) { return ''; },
            selectFn: function(event, item) {
                that.renderThread(item.id);
            },
            customContainerFn: el8.template.render.medsHx.mindreaderContainer,
            customRenderFn: function(mr, results) {
                for (var type in results) {
                    if (results.hasOwnProperty(type)) {
                        var originalKey = type;
                        var type = type.replace('_', '-'); // perm_rx -> perm-rx
                        var $section = $('.mr-extra-section[data-type="'+type+'"]', mr.$dropdownContainer);
                        var $header = $('.mr-descriptionText[data-type="'+type+'"]', mr.$dropdownContainer);
                        mr.resultsMap[type] = results[originalKey];
                        if (mr.resultsMap[type].length) {
                            $section.show();
                            $header.show();
                            for (var i=0; i<mr.resultsMap[type].length; i++) {
                                var a = mr.createDropdownItem(type, i, ['mr-result-item']);
                                a.html(mr.formatResult(mr.resultsMap[type][i]));
                                $section.append(a);
                            }
                        } else {
                            $section.hide();
                            $header.hide();
                        }
                    }
                }
            }
        });
        that._searchMindreader.init($input);
    };

    /**
     * Manage viewing Rx details
     */
    that._refreshRxDetail = function() {
        if (that.getDrawer()) {
            that.getDrawer().refreshOrderDetails();
        }
    };
    that._showRxDetail = function(orderId) {
        that._renderer.highlight(orderId);
        that.openDrawer({orderId: orderId});
    };
    that._hideRxDetail = function(orderId) {
        that.closeDrawer();
    };

    /**
     * Manage related threads viewing
     */
    that._renderRelatedThreads = function() {
        var $relatedItems = $('#meds-hx-related-items', that.getContentElt());
        if ($relatedItems.children().length === 0) {
            $relatedItems.empty().addClass('dataLoading');
            that._fetchThread(_currThreadIds, function(data) {
                var threads = el8.ptdata.medOrderThreads.create(data, true);
                that._drawRelatedThreads(threads);
                $relatedItems.removeClass('dataLoading');
            });
        }
    };
    that._drawRelatedThreads = function(threads) {
        var results = el8.ptdata.medOrderThreads.sortThreads(threads, function(t) {
            return that._renderer.getThreadSoyMap(t, true);
        });
        $('#meds-hx-related-items', that.getContentElt()).html(
            el8.template.render.medsHx.relatedThreadsList(results)
        );
    };
    that._removeRelatedSection = function() {
        $('#meds-hx-related-section', that.getContentElt()).remove();
    };
    that._displayRelatedSection = function() {
        $('.meds-hx-content', that.getContentElt()).append(
            el8.template.render.medsHx.relatedThreadSection()
        );
        el8.uiwidget.collapsible({
            container: $('#meds-hx-related-items', that.getContentElt()),
            triggerElt: $('#meds-hx-related-trigger', that.getContentElt()),
            statusElt: $('#meds-hx-related-status', that.getContentElt()),
            isCollapsed: true,
            expandFn: function() {
                that._renderRelatedThreads();
            }
        });
    };

    return that;

})();
